// extracted by mini-css-extract-plugin
module.exports = {"info-group":"RenderInfo_info-group__knPSI","label":"RenderInfo_label__3gaBL","detail":"RenderInfo_detail__jPdih"};